import { SxProps } from "@mui/material";
import Paper from "@mui/material/Paper";
import { type FC, type PropsWithChildren } from "react";

type TopRowProps = PropsWithChildren<{
    sx?: SxProps;
}>;

export const TopRow: FC<TopRowProps> = ({ children, sx }) => {
    return <Paper sx={{ py: 5, px: 4, width: "100%", ...sx }}>{children}</Paper>;
};
